// extracted by mini-css-extract-plugin
export default {"form":"quality-from_form__yWo4r","field":"quality-from_field__Qnf9U","checkbox":"quality-from_checkbox__2ZLjP","error":"quality-from_error__wesE5","link":"quality-from_link__RcjOT"};